module.exports = __webpack_public_path__ + "img/Swiss-Air.ca089a1b.png";